import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthenticatedContext } from '@ktag/commons';
import { Header } from '@ktag/styleguide/dist/react';
import config from '../../utils/AppConfig';
import useAppState from '../../AppStore';

const Heading = () => {
  const { t } = useTranslation('agisviewer');
  const [sessionInfo, setSessionInfo] = useState(null);
  const isLoggedIn = useAppState((state) => state.isLoggedIn);
  const user = useAuthenticatedContext(false);

  useEffect(() => {
    if (!user || !isLoggedIn) {
      document.documentElement.setAttribute('data-session-info', '');
      setSessionInfo(null);
      return;
    }

    const nextSessionInfo = {
      ...user,
      givenname: user.givenName, // hack to fix header component
      familyname: user.familyName, // hack to fix header component
    } as any;
    document.documentElement.setAttribute(
      'data-session-info',
      JSON.stringify(nextSessionInfo),
    );
    setSessionInfo(nextSessionInfo);
  }, [user, isLoggedIn]);

  return (
    <Header
      siteName={t('app_name')}
      displayUserInfo
      contextsApi={config.apis.profile}
      loginUrl={config.apis.login}
      simulateSession={sessionInfo}
      redirectTarget={`${document.location.origin}${config.basename}`}
    />
  );
};

export default Heading;
